import { products } from '@/mocks/products';

type Product = (typeof products)[number];
type Props = { p: Product; index: number; size?: 'lg' | 'md' | 'sm' };

const TITLE = {
  lg: 'text-[28px] md:text-[44px] lg:text-[52px] leading-[1.02]',
  md: 'text-[22px] md:text-[26px] leading-tight',
  sm: 'text-[19px] md:text-[21px] leading-tight',
};

export const fmtPrice = (n: number) => `$${n.toFixed(2)}`;

export default function ProductCaption({ p, index, size = 'md' }: Props) {
  return (
    <div className="mt-5 min-w-0">
      <p className="text-[11px] tracking-[0.14em] uppercase text-[#77726c] tabular-nums">
        {String(index).padStart(2, '0')} <span className="mx-1.5 opacity-50">/</span> {p.category}
      </p>
      <div className="mt-2 flex items-baseline justify-between gap-6">
        <h2 className={`fold-serif tracking-[-0.01em] min-w-0 ${TITLE[size]}`}>{p.name}</h2>
        <span className="text-[15px] tabular-nums text-[#171515] whitespace-nowrap">{fmtPrice(p.price)}</span>
      </div>
      <div className="mt-2 flex items-end justify-between gap-6">
        <p title={p.note} className={`min-w-0 truncate text-[14px] md:text-[15px] leading-relaxed text-[#55504b] ${size === 'lg' ? 'max-w-[460px]' : 'max-w-[360px]'}`}>{p.note}</p>
        <span className="hidden sm:inline-flex items-center gap-2 text-[11px] tracking-[0.14em] uppercase whitespace-nowrap text-[#171515]">
          <span className="bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-left-bottom bg-[length:0%_1px] group-hover:bg-[length:100%_1px] group-focus-visible:bg-[length:100%_1px] transition-[background-size] duration-500 pb-0.5">View</span>
          <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  );
}